import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useReadShift = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ shift, setShift ] = useState([]);
    const [ fetchingShift, setFetchingShift ] = useState(true);

    /** read shift
     * @param {integer} id - shift id
     * @returns {object} - shift */ 
    const readShift = async (id) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingShift')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/shifts/" + id, options);

            removeMessage(msgId);

            if (result && result.status === 200 && result.data) {
                setShift(result.data);
                setFetchingShift(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.shiftNotFound') });
                setFetchingShift(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingShiftFailed') });
            setFetchingShift(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingShiftFailed') });
            setFetchingShift(false);
            return error;
        }
    }

    return { shift, fetchingShift, readShift };

}

export default useReadShift;
